import { App as AntdApp, ConfigProvider } from 'antd';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../assets/styles/custom/pages/community.scss';
import Loader from '../components/Loader';
import TapPageVarSnippets, { MsClarityScript } from '../components/TapPageVarSnippets';
import { getUniversityId } from '../helpers/Helpers';
import { NavigateWrapper } from '../helpers/navigateWrapper';
import { useAppDispatch, useAppSelector } from '../hooks/store';
import { useIsMobile } from '../hooks/useIsMobile';
import { WIDGET_INFO } from '../redux/actions/widgetActions';
import { getIsMobile, getIsWidgetLoaded } from '../redux/selectors';
import { getAccountSlice } from '../redux/selectors/common-selectors';
import CommunityRouter from './CommunityRouter';
var CommunityApp = function () {
    var isMobile = useAppSelector(getIsMobile);
    var widgetLoaded = useAppSelector(getIsWidgetLoaded);
    var account = useAppSelector(getAccountSlice);
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var universityId = getUniversityId();
    useIsMobile('(max-width: 750px)');
    useEffect(function () {
        dispatch({
            type: WIDGET_INFO,
            payload: {
                university_id: universityId ? universityId : null,
            },
        });
        NavigateWrapper.init(navigate);
    }, []);
    if (account.isLoading || !widgetLoaded) {
        return React.createElement(Loader, null);
    }
    return (React.createElement(ConfigProvider, { theme: {
            token: {
                borderRadius: 2,
                colorPrimary: '#ff5100',
                fontSize: isMobile ? 12 : 14,
                colorError: '#D90000',
                fontFamily: "'Poppins', sans-serif",
                colorLinkHover: 'rgba(255, 81, 0, 0.6)',
            },
            components: {
                Input: {
                    borderRadius: 6,
                    fontSizeIcon: 16,
                    fontSize: isMobile ? 12 : 16,
                },
                Select: {
                    borderRadius: 6,
                    fontSizeIcon: 16,
                    colorIcon: '#222222',
                    fontSize: isMobile ? 12 : 16,
                },
                Checkbox: {
                    colorPrimary: '#222222',
                    colorPrimaryHover: '#222222',
                    colorError: '#D90000',
                },
                Button: {
                    borderRadius: 6,
                },
            },
        } },
        React.createElement(AntdApp, null,
            React.createElement(MsClarityScript, null),
            React.createElement(TapPageVarSnippets, null),
            React.createElement("main", { className: "community-container" },
                React.createElement(CommunityRouter, null)))));
};
export default CommunityApp;
